webpackJsonp([81928371033030],{

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  max-width: 90%;\n  max-height: ', ';\n'], ['\n  max-width: 90%;\n  max-height: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n'], ['\n  font-size: ', ';\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['  \n  width: ', ';\n'], ['  \n  width: ', ';\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  width: 90%;\n  height: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem auto;\n\n  ', ';\n'], ['\n  width: 90%;\n  height: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1rem auto;\n\n  ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  display: block;\n  font-weight: bold;\n  padding: ', ' 0 0 0;\n'], ['\n  display: block;\n  font-weight: bold;\n  padding: ', ' 0 0 0;\n']),
	    _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: block;\n  padding: 1rem ', ';\n  text-align: center;\n  cursor: pointer;\n  text-decoration: none;\n  color: ', ';\n\n  &:hover {\n    background-color: ', ';\n  }\n'], ['\n  display: block;\n  padding: 1rem ', ';\n  text-align: center;\n  cursor: pointer;\n  text-decoration: none;\n  color: ', ';\n\n  &:hover {\n    background-color: ', ';\n  }\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ramda = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Img = _styledComponents2.default.img(_templateObject, function (_ref) {
	  var theme = _ref.theme;
	  return theme.scale(8);
	});
	
	var Name = _styledComponents2.default.cite(_templateObject2, function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.scale(0);
	});
	
	var Li = _styledComponents2.default.li(_templateObject3, function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.scale(13);
	});
	
	var ImgContainer = _styledComponents2.default.div(_templateObject4, function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.scale(8);
	}, function (props) {
	  return props.needWhiteBg ? 'background-color: ' + props.theme.colors.white + ';' : '';
	});
	
	var Years = _styledComponents2.default.span(_templateObject5, function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.scale(-6);
	});
	
	var A = _styledComponents2.default.a(_templateObject6, function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.scale(-6);
	}, function (_ref7) {
	  var theme = _ref7.theme;
	  return theme.colors.white;
	}, function (_ref8) {
	  var theme = _ref8.theme;
	  return theme.colors.blackShades[0];
	});
	var getYears = function getYears(years) {
	  return (0, _ramda.head)(years) + '/' + (0, _ramda.last)(years);
	};
	
	var Education = function Education(props) {
	  return _react2.default.createElement(
	    Li,
	    null,
	    _react2.default.createElement(
	      A,
	      { href: props.link, target: '_blank' },
	      _react2.default.createElement(
	        'figure',
	        null,
	        _react2.default.createElement(
	          ImgContainer,
	          { needWhiteBg: props.needWhiteBg },
	          _react2.default.createElement(Img, { src: '/imgs/' + props.img, alt: props.name, title: props.fullName })
	        ),
	        _react2.default.createElement(
	          'figcaption',
	          null,
	          _react2.default.createElement(
	            Name,
	            null,
	            props.subject[props.langKey]
	          ),
	          _react2.default.createElement(
	            Years,
	            null,
	            getYears(props.years)
	          )
	        )
	      )
	    )
	  );
	};
	
	Education.propTypes = {
	  name: _propTypes2.default.string.isRequired,
	  needWhiteBg: _propTypes2.default.bool,
	  years: _propTypes2.default.array.isRequired,
	  img: _propTypes2.default.string.isRequired,
	  fullName: _propTypes2.default.string,
	  subject: _propTypes2.default.object.isRequired,
	  langKey: _propTypes2.default.string.isRequired,
	  link: _propTypes2.default.string.isRequired
	};
	
	exports.default = Education;
	module.exports = exports['default'];

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n  margin: 1rem 0 0 0;\n  padding: 0;\n'], ['\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-around;\n  margin: 1rem 0 0 0;\n  padding: 0;\n']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(6);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _H = __webpack_require__(27);
	
	var _H2 = _interopRequireDefault(_H);
	
	var _Education = __webpack_require__(120);
	
	var _Education2 = _interopRequireDefault(_Education);
	
	var _reactIntl = __webpack_require__(7);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Ul = _styledComponents2.default.ul(_templateObject);
	
	var Educations = function Educations(_ref) {
	  var educations = _ref.educations,
	      langKey = _ref.langKey;
	
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      _reactIntl.FormattedMessage,
	      { id: 'resume.educations' },
	      function (txt) {
	        return _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_reactHelmet2.default, {
	            title: txt,
	            meta: [{ name: 'description', content: txt }]
	          }),
	          _react2.default.createElement(
	            _H2.default,
	            null,
	            txt
	          )
	        );
	      }
	    ),
	    _react2.default.createElement(
	      Ul,
	      null,
	      educations.map(function (education, i) {
	        return _react2.default.createElement(_Education2.default, _extends({
	          key: i,
	          langKey: langKey
	        }, education));
	      })
	    )
	  );
	};
	
	Educations.propTypes = {
	  educations: _propTypes2.default.array.isRequired,
	  langKey: _propTypes2.default.string.isRequired
	};
	
	exports.default = Educations;
	module.exports = exports['default'];

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ResumeContainer = __webpack_require__(26);
	
	var _ResumeContainer2 = _interopRequireDefault(_ResumeContainer);
	
	var _Educations = __webpack_require__(121);
	
	var _Educations2 = _interopRequireDefault(_Educations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EducationsPage = function EducationsPage(props) {
	  var _props$data$site$site = props.data.site.siteMetadata.resume,
	      educations = _props$data$site$site.educations,
	      menu = _props$data$site$site.menu;
	  var langKey = props.pathContext.langKey;
	
	
	  return _react2.default.createElement(
	    _ResumeContainer2.default,
	    {
	      menu: menu,
	      selectedPage: '/resume/education/'
	    },
	    _react2.default.createElement(_Educations2.default, {
	      educations: educations,
	      langKey: langKey
	    })
	  );
	};
	
	EducationsPage.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  pathContext: _propTypes2.default.object.isRequired
	};
	
	exports.default = EducationsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _EducationsPage = __webpack_require__(122);
	
	var _EducationsPage2 = _interopRequireDefault(_EducationsPage);
	
	var _graphql = __webpack_require__(13);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_EducationsPage2.default, props);
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-resume-education-index-en-js-7e69788dd9427d97fef8.js